// @ts-nocheck
/**
 * tourSteps.ts
 * App.vue basicTourSteps computed の配列を生成
 * App.vue から切り出し
 */

import { requestAddLayers } from '@/js/layerEngine/addLayersGate'

type VM = any

export function getBasicTourSteps(vm: VM) {
  return [
    {
      targetSelector: '#layer-selection-btn',
      message: 'まず、レイヤーボタンをクリックしてみましょう。様々な地図レイヤーを選択できます。',
      position: 'bottom',
      showOverlay: false,
      onEnter: () => {
        // 指定位置にアニメーション付きで移動（宮崎市）
        const map = vm.$store.state.map01
        if (map) {
          setTimeout(() => {
            map.flyTo({
              center: [131.42326573295776, 31.916615363609104],
              zoom: 15,
              duration: 2000
            })
          }, 500)
        }
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: 'これがレイヤーリストです。ここから様々なレイヤーを選択できます。',
      position: 'right',
      showOverlay: false,
      delayShow: 400, // ウィンドウが開くのを待つ
      onEnter: () => {
        // レイヤーパネルを開く
        vm.$store.dispatch('showFloatingWindow', 'layer-window-map01')
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: '「最新写真」と「OSMベクター」を追加してみましょう！',
      position: 'right',
      showOverlay: false, // 地図を見せるためオーバーレイなし
      onEnter: () => {
        // 航空写真レイヤーを追加（layers.jsの定義に合わせた形式）
        const seamlessPhotoLayer = {
          id: 'oh-seamlessphoto',
          label: '最新写真',
          source: { id: 'seamlessphoto', obj: { type: 'raster', tiles: ['https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg'], tileSize: 256 } },
          layers: [{ id: 'oh-seamlessphoto', source: 'seamlessphoto', type: 'raster' }],
          opacity: 1,
          visibility: true
        }
        // OSMベクターレイヤー
        const osmVectorLayer = {
          id: 'oh-vector-layer-osm-bright',
          label: 'OSMベクター',
          sources: osmBrightSources,
          layers: osmBrightLayers,
          opacity: 1,
          visibility: true,
          attribution: '© <a href="https://wiki.openstreetmap.org/wiki/Japan/OSMFJ_Tileserver" target="_blank">OpenStreetMap</a> contributors'
        }
        const selectedLayers = vm.$store.state.selectedLayers.map01

        // 最新写真の処理
        const seamlessIndex = selectedLayers.findIndex(l => l.id === 'oh-seamlessphoto')
        if (seamlessIndex !== -1) {
          // すでに存在する場合は削除（後で先頭に追加）
          selectedLayers.splice(seamlessIndex, 1)
        }

        // OSMベクターの処理
        const osmIndex = selectedLayers.findIndex(l => l.id === 'oh-vector-layer-osm-bright')
        if (osmIndex !== -1) {
          // すでに存在する場合は削除（後で追加）
          selectedLayers.splice(osmIndex, 1)
        }

        // 1:最新写真（先頭）、2:OSMベクター（2番目）の順で追加
        selectedLayers.unshift(osmVectorLayer)
        selectedLayers.unshift(seamlessPhotoLayer)

        // レイヤーを実際に追加（map01対象）
        requestAddLayers(vm.$store, 'map01')
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: 'スライダーで透過度を調整できます。自動でデモをお見せします...',
      position: 'right',
      showOverlay: false, // 地図を見せるためオーバーレイなし
      onEnter: () => {
        // 透過度アニメーションをループ実行
        // setPaintPropertyで直接更新
        const layers = vm.$store.state.selectedLayers.map01
        const layer = layers.find(l => l.id === 'oh-seamlessphoto')
        const map = vm.$store.state.map01
        if (layer && map) {
          // 透過度を0〜1の0.01刻みで順に変化（1→0→1...ループ）
          let opacity = 1
          let direction = -0.01
          const animateLoop = () => {
            const opacityValue = Math.round(opacity * 100) / 100
            layer.opacity = opacityValue
            // 直接マップのレイヤー透過度を更新（inputSliderと同じ）
            if (layer.layers) {
              layer.layers.forEach(layerDef => {
                if (layerDef.type === 'raster') {
                  map.setPaintProperty(layerDef.id, 'raster-opacity', opacityValue)
                }
              })
            }
            opacity += direction
            if (opacity <= 0) { opacity = 0; direction = 0.01 }
            if (opacity >= 1) { opacity = 1; direction = -0.01 }
            vm.opacityAnimationTimer = setTimeout(animateLoop, 40)
          }
          setTimeout(animateLoop, 40)
        }
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: 'レイヤー左端のアイコンをドラッグ＆ドロップで順番を入れ替えられます。自動でデモをお見せします...',
      position: 'right',
      showOverlay: false,
      onEnter: () => {
        // まず透過度を1に戻す（透過度デモからの継続のため）
        const map = vm.$store.state.map01
        const layers = vm.$store.state.selectedLayers.map01
        const seamlessLayer = layers.find(l => l.id === 'oh-seamlessphoto')
        if (seamlessLayer) {
          seamlessLayer.opacity = 1
          // マップの透過度も1に戻す
          if (map && seamlessLayer.layers) {
            seamlessLayer.layers.forEach(layerDef => {
              if (layerDef.type === 'raster') {
                try {
                  map.setPaintProperty(layerDef.id, 'raster-opacity', 1)
                } catch (e) {
                  // レイヤーがまだない場合は無視
                }
              }
            })
          }
        }
        // レイヤーを反映（map01対象）
        requestAddLayers(vm.$store, 'map01')

        // ドラッグハンドルを強調表示
        setTimeout(() => {
          const handleIcons = document.querySelectorAll('#layer-window-map01 .handle-icon')
          handleIcons.forEach(icon => {
            icon.classList.add('tour-highlight')
          })
        }, 100)

        // レイヤー順を交互に入れ替えるループアニメーション
        let isOsmOnTop = false
        const swapLayers = () => {
          const selectedLayers = vm.$store.state.selectedLayers.map01
          if (isOsmOnTop) {
            // 最新写真を最前面に
            const seamlessIndex = selectedLayers.findIndex(l => l.id === 'oh-seamlessphoto')
            if (seamlessIndex !== -1 && seamlessIndex !== 0) {
              const layer = selectedLayers.splice(seamlessIndex, 1)[0]
              selectedLayers.unshift(layer)
              requestAddLayers(vm.$store, 'map01')
            }
          } else {
            // OSMベクターを最前面に
            const osmIndex = selectedLayers.findIndex(l => l.id === 'oh-vector-layer-osm-bright')
            if (osmIndex !== -1 && osmIndex !== 0) {
              const layer = selectedLayers.splice(osmIndex, 1)[0]
              selectedLayers.unshift(layer)
              requestAddLayers(vm.$store, 'map01')
            }
          }
          isOsmOnTop = !isOsmOnTop
          vm.layerSwapTimer = setTimeout(swapLayers, 2000)
        }
        // 1秒後に開始
        setTimeout(swapLayers, 1000)
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: 'レイヤー名左のゴミ箱アイコンで削除できます。自動でデモをお見せします...',
      position: 'right',
      showOverlay: false,
      onEnter: () => {
        // ドラッグハンドルの強調を解除
        const handleIcons = document.querySelectorAll('#layer-window-map01 .handle-icon')
        handleIcons.forEach(icon => {
          icon.classList.remove('tour-highlight')
        })

        const selectedLayers = vm.$store.state.selectedLayers.map01

        // まず最新写真を最前面に移動
        const seamlessIndex = selectedLayers.findIndex(l => l.id === 'oh-seamlessphoto')
        if (seamlessIndex !== -1 && seamlessIndex !== 0) {
          const layer = selectedLayers.splice(seamlessIndex, 1)[0]
          selectedLayers.unshift(layer)
        }
        requestAddLayers(vm.$store, 'map01')

        // ゴミ箱アイコンを強調表示
        setTimeout(() => {
          const deleteIcons = document.querySelectorAll('#layer-window-map01 .delete-div')
          deleteIcons.forEach(icon => {
            icon.classList.add('tour-highlight')
          })
        }, 100)

        // 2秒後に最新写真を削除
        setTimeout(() => {
          const layers = vm.$store.state.selectedLayers.map01
          const idx = layers.findIndex(l => l.id === 'oh-seamlessphoto')
          if (idx !== -1) {
            layers.splice(idx, 1)
            requestAddLayers(vm.$store, 'map01')
          }

          // さらに2秒後にOSMベクターを削除
          setTimeout(() => {
            const layers2 = vm.$store.state.selectedLayers.map01
            const idx2 = layers2.findIndex(l => l.id === 'oh-vector-layer-osm-bright')
            if (idx2 !== -1) {
              layers2.splice(idx2, 1)
              requestAddLayers(vm.$store, 'map01')
            }
          }, 2000)
        }, 2000)
      }
    },
    {
      targetSelector: '#layer-window-map01',
      message: 'このように、レイヤーリストから好きなレイヤーを追加し、順番や透過度を調整できます。ツアー（レイヤー編）は以上です！',
      position: 'right',
      showOverlay: false,
      onEnter: () => {
        // ゴミ箱アイコンの強調を解除
        const deleteIcons = document.querySelectorAll('#layer-window-map01 .delete-div')
        deleteIcons.forEach(icon => {
          icon.classList.remove('tour-highlight')
        })

        // 最新写真とOSMベクターを復活（最新写真が最前面）
        const selectedLayers = vm.$store.state.selectedLayers.map01

        // OSMベクターレイヤー
        const osmVectorLayer = {
          id: 'oh-vector-layer-osm-bright',
          label: 'OSMベクター',
          sources: osmBrightSources,
          layers: osmBrightLayers,
          opacity: 1,
          visibility: true,
          attribution: '© <a href="https://wiki.openstreetmap.org/wiki/Japan/OSMFJ_Tileserver" target="_blank">OpenStreetMap</a> contributors'
        }

        // 最新写真レイヤー
        const seamlessPhotoLayer = {
          id: 'oh-seamlessphoto',
          label: '最新写真',
          source: { id: 'seamlessphoto', obj: { type: 'raster', tiles: ['https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg'], tileSize: 256 } },
          layers: [{ id: 'oh-seamlessphoto', source: 'seamlessphoto', type: 'raster' }],
          opacity: 1,
          visibility: true
        }

        // 既存のレイヤーを削除してから追加
        const osmIndex = selectedLayers.findIndex(l => l.id === 'oh-vector-layer-osm-bright')
        if (osmIndex !== -1) selectedLayers.splice(osmIndex, 1)
        const seamlessIndex = selectedLayers.findIndex(l => l.id === 'oh-seamlessphoto')
        if (seamlessIndex !== -1) selectedLayers.splice(seamlessIndex, 1)

        // 1:最新写真（先頭）、2:OSMベクター（2番目）の順で追加
        selectedLayers.unshift(osmVectorLayer)
        selectedLayers.unshift(seamlessPhotoLayer)

        requestAddLayers(vm.$store, 'map01')
      }
      // レイヤーパネルは開いたままにする
    }
  ]
}
